/* Proof Strip — toggle a certification badge to expand its dossier card.
   Reads dossier content from data-* attributes on each badge. */
(function () {
  function initProof(root) {
    if (!root || root.dataset.proofInit === '1') return;
    root.dataset.proofInit = '1';

    var badges = Array.prototype.slice.call(root.querySelectorAll('[data-proof-badge]'));
    var dossier = root.querySelector('[data-proof-dossier]');
    if (!badges.length || !dossier) return;

    var dPre = dossier.querySelector('[data-proof-pre]');
    var dTitle = dossier.querySelector('[data-proof-title]');
    var dDesc = dossier.querySelector('[data-proof-desc]');
    var dCovers = dossier.querySelector('[data-proof-covers]');
    var dWar = dossier.querySelector('[data-proof-warranty]');
    var wNum = dossier.querySelector('[data-proof-wnum]');
    var wLabel = dossier.querySelector('[data-proof-wlabel]');
    var current = -1;

    var check = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>';

    function toggle(i) {
      var badge = badges[i];
      if (current === i) {
        badge.classList.remove('is-active');
        dossier.classList.remove('is-open');
        current = -1;
        return;
      }
      badges.forEach(function (b, k) { b.classList.toggle('is-active', k === i); });
      current = i;

      if (dPre) dPre.textContent = badge.getAttribute('data-pre') || '';
      if (dTitle) dTitle.textContent = badge.getAttribute('data-title') || '';
      if (dDesc) dDesc.textContent = badge.getAttribute('data-desc') || '';

      if (dCovers) {
        var covers = (badge.getAttribute('data-covers') || '').split(';;').filter(Boolean);
        dCovers.innerHTML = covers.map(function (c) {
          return '<span class="eb-proof__cover">' + check + esc(c) + '</span>';
        }).join('');
      }

      var warYears = badge.getAttribute('data-warranty');
      if (warYears && dWar) {
        if (wNum) wNum.innerHTML = esc(warYears) + '<span class="u">' + esc(badge.getAttribute('data-warranty-unit') || 'yr') + '</span>';
        if (wLabel) wLabel.textContent = badge.getAttribute('data-warranty-label') || 'Standard warranty';
        dWar.style.display = 'block';
        setTimeout(function () { dWar.classList.add('is-shown'); }, 120);
      } else if (dWar) {
        dWar.style.display = 'none';
        dWar.classList.remove('is-shown');
      }

      dossier.classList.add('is-open');
    }

    function esc(t) { var d = document.createElement('div'); d.textContent = t || ''; return d.innerHTML; }

    badges.forEach(function (b, i) {
      b.addEventListener('click', function () { toggle(i); });
    });
  }

  function boot() {
    document.querySelectorAll('[data-proof]').forEach(initProof);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-proof]');
    if (root) initProof(root);
  });
})();
